import { addCivilDays, startOfCivilDayInZone } from '@mfw/common';
import { endOfDay, parseISO, startOfDay } from 'date-fns';

/**
 * The calendar works in `yyyy-MM-dd`; the API takes instants. The range is
 * widened to the full day on both ends, so an event late on the last day of
 * the range is not cut off by a midnight boundary — the browser's LOCAL day,
 * or the day in `timeZone` when given (the organization's "today", which a
 * browser in another zone cuts at the wrong midnight).
 */
export const dayRangeQuery = (
  from?: string,
  to?: string,
  timeZone?: string,
) => ({
  ...(from
    ? {
        from: (timeZone
          ? startOfCivilDayInZone(from, timeZone)
          : startOfDay(parseISO(from))
        ).toISOString(),
      }
    : {}),
  ...(to
    ? {
        // inclusive: the last instant before the next day starts
        to: (timeZone
          ? new Date(
              startOfCivilDayInZone(addCivilDays(to, 1), timeZone).getTime() -
                1,
            )
          : endOfDay(parseISO(to))
        ).toISOString(),
      }
    : {}),
});
